import "./base.js";
import "../../../utilities/iso_date.js";
import "../collections/appointment_grid_dates.js";
import "../helpers/appointment_grid_date_fetcher.js";
import "./calendar/month_days.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Views ??= {};

// Preserve sub-classes (Calendar.MonthDays from ./calendar/month_days.js)
// attached to the placeholder namespace by the eager imports above.
// Without this, replacing the Calendar namespace with the new class below
// drops MonthDays and the render() throws "MonthDays is not a constructor".
const __previousCalendar = AppointmentBooking.SlotPickerModal.Views.Calendar;

AppointmentBooking.SlotPickerModal.Views.Calendar = class Calendar extends (
  AppointmentBooking.SlotPickerModal.Views.BaseTabView
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.render = this.render.bind(this);
    this.advanceMonth = this.advanceMonth.bind(this);
    this.fetchDates = this.fetchDates.bind(this);
    this.stepDate = this.stepDate.bind(this);
  }

  initialize(options = {}) {
    super.initialize(options);
    this.options = _.defaults({}, options, { api: "slot_picker_modal_calendar" });
    this.model.set({ calendarDate: moment(this.model.get("focusDate")) });
    this.dateFetcher = new AppointmentBooking.SlotPickerModal.Helpers.AppointmentGridDateFetcher(this.options);
    this.appointmentGridDates = new AppointmentBooking.SlotPickerModal.Collections.AppointmentGridDates();
    // Auto-advance to the next month(s) if the current month has no slots (on initial render and filter changes)
    this.autoAdvanceCount = 0;
    this.maxAutoAdvances = 6;

    // BEHAVIOUR

    this.listenTo(this.model, "change:calendarDate", this.render);
    return this.listenTo(this.model.get("filters"), "change", this.handleFilterChange);
  }

  // EVENT HANDLERS

  handleClickShowNextMonth() {
    return this.stepDate(1, "month");
  }

  handleClickShowPreviousMonth() {
    return this.stepDate(-1, "month");
  }

  handleFilterChange() {
    return this.render();
  }

  // RENDERING

  contextForRender() {
    const context = super.contextForRender();
    context.canShowPreviousMonth = moment(this.model.get("calendarDate"))
      .startOf("month")
      .isAfter(moment(this.model.get("focusDate")).startOf("month"));
    return context;
  }

  render() {
    return this.fetchDates().then(() => {
      // If no slots found in the current month, step forward to the next month
      if (!this.appointmentGridDates.length && this.autoAdvanceCount < this.maxAutoAdvances) {
        this.autoAdvanceCount++;
        return this.advanceMonth();
      }

      super.render();
      if (!this.appointmentGridDates.length) {
        return;
      }

      const monthDaysView = new AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays({
        renderLinks: this.options.renderLinks,
        model: new Backbone.Model({
          calendarDate: this.model.get("calendarDate"),
          appointmentGridDates: this.appointmentGridDates,
        }),
      });

      return this.replaceContents(".calendar-table", monthDaysView.render().el);
    });
  }

  // PRIVATE

  advanceMonth() {
    const nextMonth = moment(this.model.get("calendarDate")).add(1, "month");
    return this.model.set("calendarDate", nextMonth);
  }

  fetchDates() {
    let params = {
      after_date: Sparkle.Utilities.isoDate(moment(this.model.get("calendarDate")).startOf("month").startOf("week")),
      before_date: moment(this.model.get("calendarDate"))
        .endOf("month")
        .endOf("week")
        .add(1, "day")
        .format("YYYY-MM-DD"),
    };

    params = {
      ...this.model.get("filters").toJSON(),
      ...params,
    };

    return this.dateFetcher
      .fetch(params)
      .then((appointmentGridDates) => this.appointmentGridDates.set(appointmentGridDates));
  }

  stepDate(step, unit) {
    this.autoAdvanceCount = this.maxAutoAdvances; // Disable auto-advance on manual navigation
    const date = this.model.get("calendarDate");
    return this.model.set("calendarDate", moment(date).add(step, unit));
  }
};

AppointmentBooking.SlotPickerModal.Views.Calendar.prototype.tagName = "div";
AppointmentBooking.SlotPickerModal.Views.Calendar.prototype.className =
  "appointment-booking-slot-picker-modal-calendar";
AppointmentBooking.SlotPickerModal.Views.Calendar.prototype.template =
  "appointment_booking/slot_picker_modal/templates/calendar";

AppointmentBooking.SlotPickerModal.Views.Calendar.prototype.events = {
  "click [data-appointment-booking-slot-picker-modal-behaviour=show-previous-month]": "handleClickShowPreviousMonth",
  "click [data-appointment-booking-slot-picker-modal-behaviour=show-next-month]": "handleClickShowNextMonth",
};

if (__previousCalendar) {
  Object.assign(AppointmentBooking.SlotPickerModal.Views.Calendar, __previousCalendar);
}
